var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"appButton btn",class:_vm.type,on:{"click":_vm.onClick}},[_vm._t("default"),(_vm.icon)?_c('app-icon',{attrs:{"width":_vm.iconStyle.width,"height":_vm.iconStyle.height}},[_c('icon-arrow-right')],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }